import { Card, Spin } from "antd";

// What an applicant wrote, shown when HR expands their row in the
// applicants and referrals lists: the referrer's note, the applicant's own
// note (stored as cover_letter; the careers form asks "Anything you'd like us
// to know?") and their screening answers. Styles (.compact-card, .qa-item)
// come from the list pages.

const formatAnswer = (answer) => {
  if (answer === "True") return "Yes";
  if (answer === "False") return "No";
  if (typeof answer === "boolean") return answer ? "Yes" : "No";
  return answer;
};

const hasText = (value) => typeof value === "string" && value.trim() !== "";

function NoteBlock({ label, text }) {
  return (
    <div className="qa-item py-2 border-bottom">
      <div className="small text-muted mb-1">{label}</div>
      <div className="small" style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
        {text}
      </div>
    </div>
  );
}

export default function ApplicantDetailsPanel({ data, loading }) {
  if (loading) {
    return (
      <div className="p-2 text-center">
        <Spin tip="Loading application details..." />
      </div>
    );
  }

  const answers = data?.answers ?? [];
  const referralNote = data?.is_internal_referral && hasText(data.note_by_user) ? data.note_by_user : null;
  const applicantNote = hasText(data?.cover_letter) ? data.cover_letter : null;

  if (!answers.length && !referralNote && !applicantNote) {
    return (
      <div className="p-2">
        <p className="text-muted mb-0 small">This applicant left no note and answered no questions.</p>
      </div>
    );
  }

  return (
    <div className="p-2">
      <Card
        title={<span className="fs-6">Application details</span>}
        className="mb-0 compact-card"
        bodyStyle={{ padding: "8px" }}
        headStyle={{ padding: "6px 12px", minHeight: "32px" }}
      >
        {referralNote && <NoteBlock label="Why do you want to refer this candidate?" text={referralNote} />}
        {applicantNote && <NoteBlock label="Applicant's note" text={applicantNote} />}
        {answers.length > 0 && (
          <div className="question-answers">
            {answers.map((answer, index) => (
              <div key={index} className="qa-item d-flex align-items-baseline py-1 border-bottom">
                <div className="question small me-2 text-muted" style={{ flex: "0 0 50%" }}>
                  {answer.question}:
                </div>
                <div className="answer small text-primary" style={{ whiteSpace: "pre-wrap" }}>
                  {formatAnswer(answer.answer) || "No answer"}
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
